/**
 * @module Experience/Plan-Details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// INTERFACES
import { FamilyDetails } from '@experience/shop/plan-details/interfaces/family-details.interface';
import {
  PlanDetailResponse,
  PlanDetailsResponse,
} from '@support/api/proxies/responses/api-2123.interface';

// MODELS
import { PlanDetailsCategoryModel } from '@experience/shop/plan-details/models/plan-details-category.model';
import { PlanOptionsModel } from '@experience/shop/plan-details/models/plan-options.model';

export class PlanDetailsResponseModel {
  /**
   * To store plan family details
   */
  public planFamilyDetails: FamilyDetails[];

  constructor(response: PlanDetailResponse, lineId: string, isAssisted?: boolean) {
    this.planFamilyDetails = [];
    const modelData = 'model-data';
    const model = 'model';
    const planDetails = 'plandetails';
    if (
      response &&
      response['model-view'] &&
      response['model-view'][model] &&
      response['model-view'][model][modelData] &&
      response['model-view'][model][modelData][planDetails] &&
      response['model-view'][model][modelData][planDetails].planDetailsResponse
    ) {
      const plansResponse: PlanDetailsResponse[] =
        response['model-view'][model][modelData][planDetails].planDetailsResponse;
      for (let i = 0; i < plansResponse.length; i++) {
        const categoryModel = new PlanDetailsCategoryModel(plansResponse[i], isAssisted);
        this.planFamilyDetails.push(this.getPlanFamilyDetails(categoryModel, lineId));
      }
    }
  }

  /**
   * To extract plan family details
   * @param categoryModel of type PlanDetailsCategoryModel
   * @param lineId of type string
   * @returns FamilyDetails
   */
  private getPlanFamilyDetails(
    categoryModel: PlanDetailsCategoryModel,
    lineId: string
  ): FamilyDetails {
    const familyDetails: FamilyDetails = {
      familyName: categoryModel.familyName,
      familyDescription: categoryModel.getCategoryDescription(),
      familyCode: categoryModel.getFamilyCode(),
      planDetails: null,
    };
    const planOptionsModel = new PlanOptionsModel(categoryModel.planOptions);
    familyDetails.planDetails = planOptionsModel.getPlanOptions();
    return familyDetails;
  }
}
